import { API_STATISTIC } from '../../Constants';
import getBrowserFingerprint from 'get-browser-fingerprint';

export const sendUserEvent = ({ type, value, projectId }) => {
  const domFunnel = document.getElementById('meta-funnel-id');
  let funnelId = projectId
  if (!projectId && domFunnel) {
    funnelId = domFunnel.getAttribute('data');
  }
  if (!funnelId) {
    console.error('FunnelId not found');
    return;
  }
  const fingerprint = getBrowserFingerprint();
  const url = `${API_STATISTIC}/?action=add&value=${value || 1}&type=${type}&funnelId=${funnelId}&fingerprint=${fingerprint}`;
  fetch(url)
    .then((res) => {
    })
    .catch((error) => {
      console.log('STATISTIC ERROR', error);
    });
};
